import { ThemeProvider } from 'styled-components';
import ConfigProvider from 'antd/lib/config-provider';

import useTheme from 'hooks/useTheme';

const WithTheme = ({ children }: any) => {
  const { stylesTheme, antdTheme } = useTheme();

  return (
    <ConfigProvider theme={antdTheme}>
      <ThemeProvider theme={stylesTheme}>
        {children}
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default WithTheme;
